import { render, staticRenderFns } from "./add-car-brand.vue?vue&type=template&id=5ce93ad5&scoped=true"
import script from "./add-car-brand.vue?vue&type=script&lang=js"
export * from "./add-car-brand.vue?vue&type=script&lang=js"
import style0 from "./add-car-brand.vue?vue&type=style&index=0&id=5ce93ad5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce93ad5",
  null
  
)

export default component.exports